import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import "./AppSidebar.css";

type Props = {
  show: boolean;
  handleClose: VoidFunction;
};

export type NavigationLink = {
  key: string;
  title: string;
  url: string;
};

export const NAVIGATION_MENU: NavigationLink[] = [
  { key: "home", title: "Home", url: "/" },
  { key: "visite", title: "Visite", url: "/visite" },
  { key: "esami", title: "Esami", url: "/esami" },
  { key: "servizi", title: "Servizi", url: "/servizi" },
  { key: "centro-convenzionato", title: "Centro Convenzionato", url: "/centro-convenzionato" },
  { key: "chi-siamo", title: "Chi Siamo", url: "/chi-siamo" },
  { key: "contatti", title: "Contatti", url: "/contatti" },
];

export default function AppSidebar({ show, handleClose }: Props) {
  const location = useLocation();
  const [visiteOpen, setVisiteOpen] = useState(false);

  useEffect(() => {
    handleClose();
    setVisiteOpen(false);
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [show]);

  return (
    <>
      {/* Overlay */}
      <div 
        className={`sidebar-overlay ${show ? 'show' : ''}`}
        onClick={handleClose}
      />

      {/* Sidebar */}
      <div className={`app-sidebar ${show ? 'show' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <div className="sidebar-logo-circle">GM</div>
          </div>
          <button 
            className="sidebar-close-btn" 
            onClick={handleClose}
            aria-label="Chiudi menu"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <nav className="sidebar-nav">
          {NAVIGATION_MENU.map((link) => {
            if (link.key === 'visite') {
              return (
                <div key={link.key} className="sidebar-dropdown">
                  <div 
                    className={`sidebar-link sidebar-dropdown-toggle ${location.pathname.startsWith('/visite') ? 'active' : ''}`}
                    onClick={() => setVisiteOpen(!visiteOpen)}
                  >
                    {link.title}
                    <FontAwesomeIcon 
                      icon={faChevronDown} 
                      className={`sidebar-dropdown-icon ${visiteOpen ? 'open' : ''}`}
                    />
                  </div>
                  {visiteOpen && (
                    <div className="sidebar-dropdown-menu">
                      <Link to="/visite/otorinolaringoiatrica" className="sidebar-dropdown-item">
                        Visita Otorinolaringoiatrica
                      </Link>
                      <Link to="/visite/pediatrica" className="sidebar-dropdown-item">
                        Visita Otorinolaringoiatrica Pediatrica
                      </Link>
                      <Link to="/visite/audiologica" className="sidebar-dropdown-item">
                        Visita Audiologica
                      </Link>
                    </div>
                  )}
                </div>
              );
            }
            return (
              <Link
                key={link.key}
                to={link.url}
                className={`sidebar-link ${location.pathname === link.url ? 'active' : ''}`}
              >
                {link.title}
              </Link>
            );
          })}
          
          <Link to="/#prenota" className="sidebar-cta-btn">
            Prenota Visita
          </Link>
        </nav>
      </div>
    </>
  );
}
